import type { GetUnconfiguredCountDTO } from '@bb/domain/dist/types';
import axios from 'axios';

const getUnconfiguredCount = async ({ includeTotal = false }) => {
  const { data } = await axios.get<GetUnconfiguredCountDTO>(
    '/listing/unconfigured_count',
    {
      params: { includeTotal },
    },
  );

  return data;
};

export default getUnconfiguredCount;
